import { Box, Rating } from "@mui/material";
import { useContext } from "react";
import { parseRating } from "../../helpers/parseRating";
import useAddZeroes from "../../hooks/useAddZeroes";
import useTranslation from "../../hooks/useTranslation";
import { CompareListContext } from "../../Providers/CompareListContext";
import cssVars from "../../styles/vars.module.scss"
import animations from "../../styles/animations.module.scss"

import PriceBox from "../price-box";

const CompareTableBody = ({parentRef}) => {
    const { compareList } = useContext(CompareListContext)

    const w = 484 + (compareList.item_count * 270)

    const { t } = useTranslation()

    const { z } = useAddZeroes()

    return (
        compareList.item_count
            ?
            <Box className={compareList.item_count && w > parentRef.current?.offsetWidth ? animations.scrollMeRight : ""} width={w}>
                <Box display="flex" alignItems="center" key="rate" bgcolor={cssVars.extraLightGray}>
                    <Box p="16px 24px " height="100%" fontWeight={500} width={214}>
                        {t("Rating")}
                    </Box>
                    {compareList?.items?.map((item) =>
                        <Box p="16px 24px" height="100%" fontWeight={500} width={270} key={item.product.canonical_url} borderLeft={`2px solid ${cssVars.extraLightGray}`} textAlign="center"
                        >
                            <Rating size="small" value={parseRating(item.product.rating_summary)} readOnly precision={0.1} sx={{ fontSize: "15px" }} />
                        </Box>
                    )}
                    <Box p="16px 24px" width={270} borderLeft={`2px solid ${cssVars.extraLightGray}`} height="100%"
                    >
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" key="price" bgcolor={"fff"}>
                    <Box p="16px 24px " height="100%" fontWeight={500} width={214}>
                        {t("Price")}
                    </Box>
                    {compareList?.items?.map((item) =>
                        <Box p="16px 24px" height="100%" fontWeight={500} width={270} key={item.product.canonical_url} borderLeft={`2px solid ${cssVars.extraLightGray}`} textAlign="center"
                        >
                            <PriceBox product={item.product} />
                        </Box>
                    )}
                    <Box p="16px 24px" width={270} borderLeft={`2px solid ${cssVars.extraLightGray}`} height="100%"
                    >
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" key="tier_price" bgcolor={cssVars.extraLightGray}>
                    <Box p="16px 24px " height="100%" fontWeight={500} width={214}>
                        {t("Volume Discount")}
                    </Box>
                    {compareList?.items?.map((item) =>
                        <Box p="16px 24px" height="100%" fontWeight={500} width={270} key={item.product.canonical_url} borderLeft={`2px solid ${cssVars.extraLightGray}`} textAlign="center"
                        >
                            {
                                item.product.price_tiers?.length > 0
                                    ?
                                    `${t("Buy")} ${item.product.price_tiers.at(-1).quantity} ${t("for")} $${z(item.product.price_tiers.at(-1).final_price.value)} ${t("each")}`
                                    :
                                    "--"
                            }
                        </Box>
                    )}
                    <Box p="16px 24px" width={270} borderLeft={`2px solid ${cssVars.extraLightGray}`} height="100%"
                    >
                    </Box>
                </Box>
                {
                    compareList?.attributes?.map((attr, i) =>
                        <Box display="flex" alignItems="center" key={attr.code} bgcolor={i % 2 !== 0 ? cssVars.extraLightGray : "fff"}>
                            <Box p="16px 24px " height="100%" fontWeight={500} width={214}>
                                {attr.label}
                            </Box>
                            {compareList?.items?.map((item) =>
                                <Box p="16px 24px" height="100%" fontWeight={400} width={270} key={item.product.canonical_url} borderLeft={`2px solid ${cssVars.extraLightGray}`} textAlign="center"
                                >
                                    {
                                        item.attributes.filter(a => a.code === attr.code).at(0).value !== "N/A"
                                            ?
                                            item.attributes.filter(a => a.code === attr.code).at(0).value
                                            :
                                            "--"
                                    }
                                </Box>
                            )}
                            <Box p="16px 24px" width={270} borderLeft={`2px solid ${cssVars.extraLightGray}`} height="100%"
                            >
                            </Box>
                        </Box>
                    )
                }
            </Box>
            :
            null
    );
}

export default CompareTableBody;